import React from "react";
import { useRecoilValue, useSetRecoilState, useRecoilState } from 'recoil';
import { authApiClientAtom, useResetApiCallErrorAtom, authAtom, currentSessionAtom, currentSessionModeAtom, isSessionActive } from '../state';
import { AppBar, Avatar, Button, Toolbar, Typography, Box, Tabs, Tab } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../api/client";

const SESSION_TABS = ["intra", "inter", "summary"]

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        marginRight: "40px",
        textAlign: 'left',
    },
    spacer: {
        flexGrow: 1,
    },
}));

const renderUserAvatar = (name, picture, onLogout) => {
    return (
        <>
            <Avatar alt={name} src={picture} />
            <Button color="inherit" onClick={onLogout}>
                Logout
            </Button>
        </>
    );
};

const a11yProps = (value) => {
    const index = SESSION_TABS.indexOf(value)
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
};

const renderSessionTabs = (value, setValue, currentSession, setCurrentSessionMode) => {
    if (!isSessionActive(currentSession)) {
        return <></>
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
        const mode = SESSION_TABS[newValue];
        setCurrentSessionMode(mode);
    };

    return (
        <Box>
            <Tabs
                textColor="inherit"
                TabIndicatorProps={{ style: { background: "white" } }}
                value={value}
                onChange={handleChange}
            >
                <Tab label="Intra ID" {...a11yProps("intra")} />
                <Tab label="Inter ID" {...a11yProps("inter")} />
                <Tab label="Summary" {...a11yProps("summary")} />
            </Tabs>
        </Box>
    )
}

const AppHeader = () => {

    const classes = useStyles();
    let auth = useRecoilValue(authAtom);
    let navigate = useNavigate();
    let authApiClient = useRecoilValue(authApiClientAtom);
    let currentSession = useRecoilValue(currentSessionAtom);
    const setCurrentSession = useSetRecoilState(currentSessionAtom);
    const setCurrentSessionMode = useSetRecoilState(currentSessionModeAtom);
    const resetApiCallErrorAtom = useResetApiCallErrorAtom();

    const resetSession = () => {
        setCurrentSession({});
        setCurrentSessionMode("intra");
        resetApiCallErrorAtom();
    };

    const [value, setValue] = useRecoilState(currentSessionModeAtom);

    const logout = async () => {
        await authApiClient.revokeToken(auth.accessToken);
        resetSession();
        navigate("/login");
    };

    const goHome = async () => {
        resetSession();
        navigate("/");
    };

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar variant="dense">
                    <Box className={classes.title}>
                        <Button color="inherit" onClick={goHome} style={{ textTransform: 'none' }}>
                            <Typography variant="h6" >
                                FR Data Cleaning
                            </Typography>
                        </Button>
                    </Box>
                    {renderSessionTabs(SESSION_TABS.indexOf(value), setValue, currentSession, setCurrentSessionMode)}
                    <Box className={classes.spacer} />
                    {isLoggedIn(auth) && renderUserAvatar(auth.name, auth.picture, logout)}
                </Toolbar>
            </AppBar>
        </div>
    );
}

export default AppHeader;
